<template>
  <v-card class="d-flex align-content-start flex-wrap mt-4 mx-4" flat tile>
    <v-dialog v-model="disciplineRefDialog" max-width="450" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <v-toolbar dark color="red">
            <v-toolbar-title
              >New Referral:
              <span class="text-h5">{{
                clickedStudentname
              }}</span></v-toolbar-title
            >
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="referral.incident"
            placeholder="Incident"
          ></v-text-field>
          <!-- <v-select
        :items="incidents"
        item-text="type"
        item-value="point"
        :auto="true"
       
        v-model="referral.incident"
        label="Select the incident"
        return-object
        ></v-select> -->
          <v-combobox
            v-model="referral.incident_location"
            :items="incidentLocation"
            label="Type or choose incident location"
          ></v-combobox>
          <v-combobox
            v-model="referral.comments"
            :items="incidentActions"
            label="Type or choose immidiate actions taken"
          ></v-combobox>
          <v-textarea
            v-model="referral.explanations"
            placeholder="Description/Details"
          ></v-textarea>

          <div class="text-center">
            <vc-date-picker mode="dateTime" v-model="referral.incident_time" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small @click="disciplineRefDialog = false"> Cancel</v-btn>
          <v-btn dark small color="red lighten-1" @click="submitReferral()">
            Submit Referral</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- one col for whole class-->
    <v-card tile class="pa-2">
      <v-card :elevation="2" width="160" dense tile>
        <v-card-title> Whole Class </v-card-title>
        <v-card-text class="pb-1">
          <v-badge overlap color="white" class="pa-0">
            <template v-slot:badge>
              <v-icon
                @click="markAllPresent()"
                :color="markAllPresentColor"
                size="30"
                class="pa-0"
                >mdi-clock</v-icon
              >
            </template>
            <v-avatar size="100" class="mb-0 mt-0">
              <v-img src="@/assets/img/wholeclass.png" elevation="10"></v-img>
            </v-avatar>
          </v-badge>
        </v-card-text>
        <v-card-actions>
          <v-btn icon @click="download">
            <v-icon small>mdi-view-list</v-icon>
          </v-btn>
          <v-spacer />
          <div v-if="showPoints" class="mt-0 pt-1">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon v-bind="attrs" v-on="on">
                  <v-icon small color="red lighten-3">mdi-thumb-down</v-icon>
                </v-btn>
              </template>

              <v-card max-width="250" class="mx-auto">
                <v-list>
                  <v-list-item
                    v-for="(item, i) in behaviorOptions.filter(
                      (i) => i.point < 0
                    )"
                    :key="i"
                  >
                    <v-chip color="red lighten-3"> {{ item.point }}</v-chip>
                    {{ item.text }}
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-chip :color="behaviorcolor" small dark dense>
              {{ behaviorPoints }}</v-chip
            >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon v-bind="attrs" v-on="on">
                  <v-icon small color="green lighten-3">mdi-thumb-up</v-icon>
                </v-btn>
              </template>

              <v-card max-width="250" class="mx-auto">
                <v-list>
                  <v-list-item
                    v-for="(item, i) in behaviorOptions.filter(
                      (i) => i.point > 0
                    )"
                    :key="i"
                  >
                    <v-chip color="green lighten-3"> {{ item.point }}</v-chip>
                    {{ item.text }}
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- cols generated for eacg student-->
    <v-card v-for="student in students" :key="student.id" tile class="pa-2">
      <v-hover v-slot="{ hover }">
        <v-card :elevation="hover ? 12 : 2" width="160" dense>
          <v-card-title class="body-2">
            <div class="headerClass">
              {{ student.full_name_2 }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-badge overlap color="white">
              <template v-slot:badge>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="updateAttendance(student)"
                      v-if="student.result === 'P'"
                      color="green"
                      size="30"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-clock
                    </v-icon>
                    <v-icon
                      @click="updateAttendance(student)"
                      v-else-if="student.result === 'A'"
                      color="red"
                      size="30"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-clock-alert</v-icon
                    >
                    <v-icon
                      @click="updateAttendance(student)"
                      v-else-if="student.result === 'T'"
                      color="orange darken-1"
                      size="30"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-clock-alert</v-icon
                    >
                    <v-icon
                      @click="updateAttendance(student)"
                      v-else-if="student.result === 'E'"
                      color="red lighten-2"
                      size="30"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-clock</v-icon
                    >
                    <v-icon
                      @click="updateAttendance(student)"
                      v-else
                      color="primary"
                      size="30"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-clock-outline</v-icon
                    >
                  </template>
                  <span>{{
                    student.result == "A"
                      ? "Absent"
                      : student.result == "T"
                      ? "Tardy"
                      : student.result == "P"
                      ? "Present"
                      : "No Record"
                  }}</span>
                </v-tooltip>
              </template>
              <v-avatar size="100">
                <v-img :src="student.img_src"></v-img>
              </v-avatar>
            </v-badge>
          </v-card-text>

          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="newDispRef(student)"
                  >mdi-shield</v-icon
                >
              </template>
              <span>Discipline Referral</span>
            </v-tooltip>
            <v-btn
              icon
              :href="
                'https://communications.buffsci.org/call-log/list?student=' +
                student.id
              "
              target="_blank"
            >
              <v-icon small>mdi-phone</v-icon>
            </v-btn>
            <v-tooltip right v-if="student.alert">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span>{{ student.alert }}</span>
            </v-tooltip>
            <v-spacer />
            <v-tooltip top v-if="(student.result == 'T' || student.result == 'A') && student.excused">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="blue" size="30" v-bind="attrs" v-on="on">
                  mdi-circle
                </v-icon>
              </template>
              <span>{{ student.excused }}</span>
            </v-tooltip>
            <div v-if="showPoints">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon small color="red lighten-3">mdi-thumb-down</v-icon>
                  </v-btn>
                </template>

                <v-card max-width="250" class="mx-auto">
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in behaviorOptions.filter(
                        (i) => i.point < 0
                      )"
                      :key="i"
                    >
                      <v-chip color="red lighten-3"> {{ item.point }}</v-chip>
                      {{ item.text }}
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <v-chip small :color="behaviorcolor" dark dense>
                {{ behaviorPoints }}</v-chip
              >
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon small color="green lighten-3">mdi-thumb-up</v-icon>
                  </v-btn>
                </template>

                <v-card max-width="250" class="mx-auto">
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in behaviorOptions.filter(
                        (i) => i.point > 0
                      )"
                      :key="i"
                    >
                      <v-chip color="green lighten-3"> {{ item.point }}</v-chip>
                      {{ item.text }}
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </v-card-actions>
        </v-card>
      </v-hover>
    </v-card>
    <div class="text-center">
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-card>
</template>

<script>
import Vue from "vue";
import VCalendar from "v-calendar";
Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});
export default {
  props: {
    showPoints: {
      required: true,
    },
    behaviorOptions: {
      required: true,
    },
  },
  data: () => ({
    snackbarText: "",
    snackbar: false,
    behaviorPoints: 0,
    students: [],
    clickedStudentId: null,
    clickedStudentname: null,
    disciplineRefDialog: false,
    disciplineRecords: [],
    timeMenu: false,
    incidentLocation: ["Classroom", "Hallway", "Outside", "Bus", "Cafeteria"],
    incidentActions: [
      "Parents contacted",
      "Student isolated",
      "Administration notified",
    ],
    referral: {
      incident: "",
      incident_location: "",
      incident_time: "",
      explanations: "",
      comments: "",
    },
    /* incidents:[
      {type:"Unprepared for class ", point:2},
      {type:"Dress code violation/ Inappropriate attire", point:3},
      {type:"Mild name calling or insults that havior", point:12},
      {type:"Minor disruptive avior, etc.)", point:2},
      {type:"Removing or refusal to ", point:3},
      {type:"Inappropriate display ", point:12},
      {type:"Projectiles ", point:2},
      {type:"Failure to turn in ", point:3},
     {type:"Failure to abide by a ", point:12},
   
    
    ] */
  }),
  computed: {
    course() {
      return this.$store.state.course;
    },
    behaviorcolor() {
      if (this.behaviorPoints < 0) return "red lighten-2";
      else return "green lighten-2";
    },
    markAllPresentColor() {
      if (this.students.find((student) => student.result === ""))
        return "primary";
      else return "green";
    },
  },
  methods: {
    csv(array) {
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    download() {
      let csv = this.csv(
        this.students.map((s) => {
          return { student_id: s.student_id, full_name: s.full_name_2 };
        })
      );
      let fileLink = document.createElement("a");
      fileLink.href = window.URL.createObjectURL(
        new Blob([csv], { type: "text/csv;charset=utf-8;" })
      );
      fileLink.setAttribute("download", "students.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    newDispRef(student) {
      this.disciplineRefDialog = true;
      this.clickedStudentId = student.id;
      this.clickedStudentname = student.full_name;
      this.referral.incident = "";
      this.referral.incident_location = "";
      this.referral.incident_time = "";
      this.referral.explanations = "";
      this.referral.comments = "";
    },
    submitReferral() {
      this.$sisApi("post", `my-schedule/discipline`, {
        user_id: this.clickedStudentId,
        incident: this.referral.incident,
        incident_location: this.referral.incident_location,
        incident_time: this.referral.incident_time,
        explanations: this.referral.explanations,
        comments: this.referral.comments,
      })
        .then(() => {
          this.disciplineRefDialog = false;
          this.snackbar = true;
          this.snackbarText = "Discipline referral is saved.";
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.snackbar = true;
            this.snackbarText = error.response.data.message;
            console.log(error.response);
          }
        });
    },
    updateAttendance(student) {
      console.log("test", student.result);
      if (student.result === "" || student.result === "P") student.result = "A";
      else if (student.result === "A") student.result = "T";
      else if (student.result === "T") student.result = "P";
      else student.result = "";
      console.log("test2", student.result);

      this.$sisApi("post", "my-schedule/attendance", {
        course_id: this.course.course_id,
        section: this.course.section,
        date: this.course.start.substr(0, 10),
        period: this.course.period,
        teachers: this.course.teacher_uids,
        user_id: student.id,
        schedule_id: student.schedule_id,
        attendance: student.result,
      })
        .then((response) => {
          var i = this.students.findIndex(
            (st) => st.student_id == student.student_id
          );
          this.students[i].result = student.result;
          this.students[i].schedule_id = response.data.id;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },
    markAllPresent() {
      let allPresent = {
        course_id: this.course.course_id,
        section: this.course.section,
        date: this.course.start.substr(0, 10),
        period: this.course.period,
      };
      this.$sisApi("post", "my-schedule/attendance/all", allPresent)
        .then((response) => {
          this.students
            .filter((student) => student.result == "")
            .forEach((student) => {
              student.result = "P";
            });
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response);
          }
        });
    },
  },
  mounted() {
    this.$sisApi("get", `my-schedule/students/${this.course.section_id}`, {
      // for past student list records
      course_id: this.course.course_id,
      section: this.course.section,
      date: this.course.start.substr(0, 10),
      period: this.course.period,
    })
      .then((response) => {
        this.students = response.data;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          console.log(error.response);
        }
      });

    this.$sisSocket("on", "attendance-update", function (incoming) {
      var i = this.students.findIndex(
        (st) => st.schedule_id == incoming.data.schedule_id
      );
      if (i >= 0) {
        this.students[i].result = incoming.data.result;
      }
    });
  },
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
